import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import styles from "./ButtonSideHeader.module.scss";
import classNames from "classnames/bind";
import HeadlessTippy from "@tippyjs/react/headless";
import HistoryView from "~/components/Popper/HistoryView";
import { Wrapper as PopperWrapper } from "../../Popper";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
const cx = classNames.bind(styles);
function ButtonSideHeader() {
    const [showResult, setShowResult] = useState(false);
    const handleHideResult = () => {
        setShowResult(false);
    };
    return (
        <span>
            <HeadlessTippy
                visible={showResult}
                // showResult && searchValue.length >
                interactive
                placement="bottom"
                render={(attrs) => (
                    <div
                        className={cx("search_result")}
                        tabIndex="-1"
                        {...attrs}
                    >
                        <PopperWrapper>
                            <h4 className={cx("search_title")}>
                                <FontAwesomeIcon icon={faClock} />
                                <span> Xem gần đây</span>
                            </h4>
                            <HistoryView />
                        </PopperWrapper>
                    </div>
                )}
                onClickOutside={handleHideResult}
            >
                <div className={cx("nav_wrap")}>
                    <Tippy content="Xem gần đây">
                        <span
                            className={cx("recent")}
                            onClick={() => setShowResult(!showResult)}
                        >
                            <FontAwesomeIcon icon={faClockRotateLeft} />
                        </span>
                    </Tippy>
                </div>
            </HeadlessTippy>
        </span>
    );
}

export default ButtonSideHeader;
